import React, { useState } from 'react';

import Badge from 'react-bootstrap/Badge'
import Button from 'react-bootstrap/Button'

class TacosContainer extends React.Component {
    constructor(props) {
        super(props)
        let me = this
    }

    componentWillMount()	{
       
        console.log('sv--task=--- link sends us params good')
        console.log(this.props.svparams)
        let id;
        if(this.props.svparams){
           id = this.props.svparams.id
        
        }else{
         console.log('not called by router we might be creat')
         id = -11;
        }
       
   console.log('sbv--sjourn id ****+++++++++++++++++++++++++++ we will use _doc as the space has details of sohourn as single flat indxex:'+ id)
   
   
    }
    render() {

        let id;
        if(this.props.svparams){
           id = this.props.svparams.id
        
        }else{
         console.log('not called by router we might be creat')
         id = -11;
        }

    return (
      <div>

        <p>
          SV TacosContainerPage Component
        </p>
      
       
     <h1>
        Blue TacosContainerPage Header
        <Badge bg="secondary" as={Button}>
          New TacosContainerPage Bage  with id  {id}
        </Badge>
      </h1>
        
      </div>
    )
  }

}

export default TacosContainer